import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Chip, Group, NumberInput, Text, Tooltip } from '@coveord/plasma-mantine';
import dayjs from 'dayjs';
import { Locales } from '../../strings/Locales.js';
import { TimePickerInput } from '../time-picker/TimePickerInput.js';
import { useFrequencyForm } from './FrequencyContext.js';
export var DailyFrequency = function DailyFrequency() {
    var form = useFrequencyForm();
    return /*#__PURE__*/ _jsx(TimePickerInput, _object_spread({
        label: Locales.format('FrequencySelector.DAILY.label')
    }, form.getInputProps('frequency.hourMinute')));
};
export var HourlyFrequency = function HourlyFrequency() {
    var form = useFrequencyForm();
    return /*#__PURE__*/ _jsx(NumberInput, _object_spread({
        label: Locales.format('FrequencySelector.HOURLY.label'),
        min: 1,
        max: 12,
        defaultValue: 1
    }, form.getInputProps('frequency.value')));
};
export var MinutelyFrequency = function MinutelyFrequency() {
    var form = useFrequencyForm();
    return /*#__PURE__*/ _jsx(NumberInput, _object_spread({
        label: Locales.format('FrequencySelector.MINUTELY.label'),
        min: 5,
        max: 30,
        step: 5,
        defaultValue: 1
    }, form.getInputProps('frequency.value')));
};
export var MonthlyFrequency = function MonthlyFrequency() {
    var form = useFrequencyForm();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(NumberInput, _object_spread({
                label: Locales.format('FrequencySelector.MONTHLY.label'),
                min: 1,
                max: 6,
                defaultValue: 1
            }, form.getInputProps('frequency.value'))),
            /*#__PURE__*/ _jsx(NumberInput, _object_spread({
                label: Locales.format('FrequencySelector.MONTHLY.monthDay.label'),
                min: 1,
                max: 28,
                defaultValue: 1
            }, form.getInputProps('frequency.monthDay'))),
            /*#__PURE__*/ _jsx(TimePickerInput, _object_spread({
                label: Locales.format('FrequencySelector.timePicker.label')
            }, form.getInputProps('frequency.hourMinute')))
        ]
    });
};
export var WeeklyFrequency = function WeeklyFrequency() {
    var form = useFrequencyForm();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        fw: 500,
                        size: "sm",
                        mb: "xs",
                        children: Locales.format('FrequencySelector.WEEKLY.label')
                    }),
                    /*#__PURE__*/ _jsxs(Chip.Group, _object_spread_props(_object_spread({
                        multiple: true
                    }, form.getInputProps('frequency.weekDays')), {
                        children: [
                            /*#__PURE__*/ _jsx(Group, {
                                gap: "xs",
                                children: Array(7).fill(0).map(function(_, i) {
                                    var _form_values_frequency_weekDays, _form_values_frequency, _form_values;
                                    var day = dayjs().day(i);
                                    return /*#__PURE__*/ _jsx(Tooltip, {
                                        label: Locales.format('FrequencySelector.WEEKLY.daysWeek.tooltip', {
                                            daysWeek: day.format('dddd')
                                        }),
                                        refProp: "rootRef",
                                        children: /*#__PURE__*/ _jsx(Chip, {
                                            value: day.format('dddd').toUpperCase(),
                                            checked: (_form_values = form.values) === null || _form_values === void 0 ? void 0 : (_form_values_frequency = _form_values.frequency) === null || _form_values_frequency === void 0 ? void 0 : (_form_values_frequency_weekDays = _form_values_frequency.weekDays) === null || _form_values_frequency_weekDays === void 0 ? void 0 : _form_values_frequency_weekDays.includes(day.format('dddd').toUpperCase()),
                                            children: day.format('dd')
                                        })
                                    }, i);
                                })
                            }),
                            form.getInputProps('frequency.weekDays').error && /*#__PURE__*/ _jsx(Text, {
                                c: "red",
                                size: "xs",
                                mt: "xs",
                                children: form.getInputProps('frequency.weekDays').error
                            })
                        ]
                    }))
                ]
            }),
            /*#__PURE__*/ _jsx(TimePickerInput, _object_spread({
                label: Locales.format('FrequencySelector.timePicker.label')
            }, form.getInputProps('frequency.hourMinute')))
        ]
    });
};

//# sourceMappingURL=FrequencySubComponents.js.map